import find from 'lodash/find'
import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'
import { useLoadingStore } from '@/stores/loading'
import { useServiceTemplatesStore } from '@/stores/serviceTemplates'
import { useCategoriesStore } from '@/stores/categories'
import { useSettingsStore } from '@/stores/settings'
import translations from './internal/Lang'

const Names = {
  fr: 'services',
  en: 'services'
}

const Config: TrPageConfigInterface = {
  name: Names.fr,
  path: `/${Names.fr}`,
  alias: `/${Names.en}`,
  meta: {
    title: {
      fr: translations['fr'].title,
      en: translations['en'].title
    }
  },
  component: () => import('@page/services/PageServices.vue'),
  beforeEnter: async (to, from, next) => {
    const loadingStore = useLoadingStore()
    const serviceTemplatesStore = useServiceTemplatesStore()
    const categoryStore = useCategoriesStore()

    loadingStore.toggleLoading({ set: true })
    await useSettingsStore().fetchGlobalSettings()
    await serviceTemplatesStore.fetchServiceTemplatesSEO()
    if (categoryStore.allCategories.length === 0) {
      await categoryStore.fetchCategories()
    }

    if (to.query.category === null) {
      categoryStore.currentCategory = null
    } else if (to.query.category) {
      categoryStore.currentCategory = find(categoryStore.allCategories, (category) => {
        return category.id === Number(to.query.category)
      })
    }

    loadingStore.toggleLoading({ set: false })

    next()
  }
}

export { Config }
